'use client';

import { Stack, Text } from '@chakra-ui/react';
import { Link } from '@/i18n/navigation';
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import CPhoneInput from '../../../PhoneInput';
import { Button } from '@/components/ui/button';
import { useSelector } from 'react-redux';
import { IRedux } from '@/_store/types';
import { CField } from '../../../CField';

function LoginDesktop({
  error,
  loading,
  values,
  onChange,
  onLogin,
  children,
}: {
  error: boolean;
  loading: boolean;
  values: { phone: string; name: string };
  onChange: (name: string, value: string) => void;
  onLogin: (e: any, onError: () => void) => void;
  children: React.ReactNode;
}) {
  const [phoneError, setPhoneError] = useState(false);

  const t = useTranslations();

  const settings = useSelector((state: IRedux) => state.settings);

  const onTelChange = (val: string) => {
    if (phoneError) setPhoneError(false);

    onChange('phone', val);
  };

  return (
    <Stack
      position={'relative'}
      as='form'
      onSubmit={(e) => onLogin(e, () => setPhoneError(true))}
      style={{ flex: 1 }}
      gap={1}
    >
      <Text color={'text'} fontSize='2xl' fontWeight={700} mb={5}>
        {t('Вход на сайт')}
      </Text>
      <CField
        label={t('phone_number')}
        invalid={phoneError || error}
        errorText={
          phoneError ? t('incorrect_phone_number') : t('error_occured')
        }
      >
        <CPhoneInput
          className='peer'
          floatingLabel
          value={values?.phone}
          onChange={(e) => typeof e === 'string' && onTelChange(e)}
        />
      </CField>

      <Text
        color={'text'}
        my={4}
        fontWeight={500}
        lineHeight={'24px'}
        textAlign={'start'}
      >
        {t('auth_agreement_prefix')}
        <Link href="/public-offer" style={{ textDecoration: 'underline' }}>
          {t('auth_agreement_link')}
        </Link>
        {t('auth_agreement_suffix')}
      </Text>
      <Stack flex={1} justify='flex-end'>
        <Button
          w='full'
          size='xl'
          type='submit'
          height='56px'
          fontSize='md'
          fontWeight={600}
          bgColor='primary'
          color='primary.text'
          _hover={{
            bg: 'primary.hover',
          }}
          loading={loading}
        >
          {settings?.data?.data?.is_otp ? t('send_code') : t('continue')}
        </Button>
      </Stack>
    </Stack>
  );
}

export default LoginDesktop;
